/**
 * Generates a random color in hexadecimal format.
 * @returns A random color in the format '#RRGGBB'.
 */
function randomColor(): string {
  const color = Math.floor(Math.random() * 0xFFFFFF);
  const r = Math.floor(color / 0x10000).toString(16).padStart(2, '0');
  const g = Math.floor((color % 0x10000) / 0x100).toString(16).padStart(2, '0');
  const b = Math.floor(color % 0x100).toString(16).padStart(2, '0');
  return `#${r}${g}${b}`;
}

function makeid(length: number): string {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

function randomIntFromInterval(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const parseUserAgent = (userAgent: string): string => {
  const matches = userAgent.match(/\(([^)]+)\)/);
  return matches ? matches[1] : '';
};

export {
  randomColor,
  makeid,
  randomIntFromInterval,
  parseUserAgent,
};
